

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface ReferralParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;

}

export interface Referral {
    id?: string;
    name: string;
    address?: string;
    clinicName?:string;
    mobile?:string;
    altMobile?:string;
    email?:string;
    isActive?:string;
    tenantId?: string;
    branchId?: string;
    parameters?: ReferralParameter[];
    links?: any;
    referralType:number;
    altMobileCountryCode?:string;
    mobileCountryCode?:string;
}

export abstract class ReferralData {

  abstract list(url: string): Observable<Referral[]>;
  abstract create(url: string,data: Referral): Observable<any>;
  abstract update(url: string,data: Referral): Observable<any>;
  abstract delete(url: string): Observable<any>;
  abstract getByType(url: string,type,typeValue): Observable<any>;
}
